<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout row wrap>
      <v-flex xs12 md5>
        <SelectCreditors
          :multiple="true"
          @selectedCreditors="ids_credores = $event"
          :selected="ids_credores"
        />
      </v-flex>
      <v-flex xs12 md3 offset-xs0 offset-md4>
        <v-menu offset-y full-width>
          <v-text-field
            slot="activator"
            label="Mês"
            :value="ano_mes_array[1] + '/' + ano_mes_array[0]"
            box
            readonly
          />
          <v-date-picker v-model="ano_mes" type="month" locale="br" />
        </v-menu>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm12 md12 class="indigo lighten-5 ma-3 pa-1">
        <v-sheet height="720">
          <v-calendar v-model="dia_calendario" color="deep-purple darken-5">
            <template v-slot:day="{ date }">
              <template v-for="event in eventsMap[date]">
                <v-menu
                  :key="event.id"
                  v-model="event.open"
                  full-width
                  offset-x
                  :close-on-content-click="false"
                  :close-on-click="true"
                >
                  <template v-slot:activator="{ on }">
                    <div
                      v-if="!event.time"
                      v-ripple
                      class="my-event"
                      :style="`border: 1px solid ${defineColorByCreditorId(
                        event
                      )}; background-color:${defineColorByCreditorId(event)}`"
                      v-on="on"
                      v-html="pegar_titulo(event)"
                      @click="abrir_evento(event)"
                    />
                  </template>
                  <v-card color="grey lighten-5" min-width="350px" flat>
                    <v-toolbar
                      :style="`background-color: ${defineColorByCreditorId(
                        event
                      )};`"
                      dark
                      class="py-2"
                    >
                      <v-toolbar-title v-html="ClickableLinks(event.title, true)" />
                      <v-spacer />
                      <v-menu offset-y>
                        <v-icon slot="activator">more_vert</v-icon>
                        <v-list class="">
                          <v-list-tile @click="abrir_editar(event)"
                            >Editar</v-list-tile
                          >
                          <v-list-tile @click="confirmar_remocao(event)"
                            >Remover</v-list-tile
                          >
                        </v-list>
                      </v-menu>
                    </v-toolbar>
                    <v-card-title primary-title>
                      <v-flex xs12>
                        <h4 class="deep-purple--text">
                          <span v-for="cred in event.creditors" :key="cred.id">
                            [ {{ cred.name }} ] &nbsp;
                          </span>
                        </h4>
                      </v-flex>
                      <v-flex xs12 class="my-1">
                        <small v-if="event.last_updated_by"
                          >Última alteração por:
                          {{ event.last_updated_by }}</small
                        >
                      </v-flex>
                      <span v-html="ClickableLinks(event.description, false)"></span>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn
                        flat
                        color="secondary"
                        @click="fechar_evento(event)"
                      >
                        Fechar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </template>
            </template>
          </v-calendar>
        </v-sheet>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialog_editar"
      max-width="700px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :persistent="true"
    >
      <EditEventModal
        :esperar="esperar"
        :item_edicao="item_edicao"
        @fechar="dialog_editar = false"
        @salvar="editar"
      />
    </v-dialog>

    <v-dialog
      v-model="dialog_criar"
      max-width="700px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :persistent="true"
    >
      <CreateEventModal
        :esperar="esperar"
        @fechar="fechar_modal_criar()"
        @salvar="criar"
      />
      ￼
    </v-dialog>

    <v-dialog
      v-model="dialog_remover"
      max-width="500px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title class="headline deep-purple white--text" primary-title>
          Remover
        </v-card-title>
        <v-card-text>
          <h3>Tem certeza que deseja remover esse elemento?</h3>
          <p>Essa ação não pode ser desfeita</p>
        </v-card-text>
        <v-divider class="deep-purple" />
        <v-card-actions class="py-2">
          <v-btn flat color="primary" @click="dialog_remover = false"
            >Fechar</v-btn
          >
          <v-spacer />
          <v-btn
            color="deep-purple"
            dark
            @click="remover_evento"
            :disabled="esperar"
            >Remover</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout row wrap>
      <v-btn dark fab bottom right fixed color="deep-purple darken-2">
        <v-icon @click="abrir_modal_criar()">add</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import store from "@/store";
import jsSHA from "jssha";
import SelectCreditors from "@/components/creditor/SelectCreditors";
import CreateEventModal from "@/views/administration/event_components/CreateEventModal";
import EditEventModal from "@/views/administration/event_components/EditEventModal";
import EventService from "@/services/event";

export default {
  components: {
    SelectCreditors,
    CreateEventModal,
    EditEventModal,
  },
  beforeMount() {
    if (Object.keys(this.$route.query).length === 0) {
      this.setar_filtros_url();
    }
    if (this.$route.query.credores) {
      this.ids_credores = this.$route.query.credores.split(",");
    }
    if (this.$route.query.data) {
      this.ano_mes = this.$route.query.data;
    }

    this.pegar_eventos();
  },
  data() {
    return {
      ano_mes: new Date().toISOString().slice(0, 10),
      events: [],
      esperar: false,
      item_remover: "",
      dialog_remover: false,
      item_edicao: {},
      dialog_editar: false,
      dialog_criar: false,
      ids_credores: [],
      evento_selecionado: {},
    };
  },
  watch: {
    ids_credores: function (depois, antes) {
      this.pegar_eventos();
    },
    ano_mes: function (depois, antes) {
      this.pegar_eventos();
    },
  },
  computed: {
    eventsMap() {
      const map = {};
      const id_evento = this.$route.query.evento;

      this.events.forEach((e) =>
        (map[e.event_time.split("T")[0]] =
          map[e.event_time.split("T")[0]] || []).push(e)
      );

      if (id_evento) {
        if (id_evento === "new") {
          this.dialog_criar = true;
        } else {
          const evento = this.events.filter((ev) => {
            return ev.id == id_evento;
          })[0];
          if (evento) {
            this.evento_selecionado = evento;
            map[evento.event_time.split("T")[0]].map((e) => {
              if (e.id == id_evento) {
                e.open = true;
              }
            });
          }
        }
      }
      return map;
    },
    ano_mes_array() {
      return this.ano_mes.split("-");
    },
    dia_calendario() {
      return this.ano_mes + "-01";
    },
  },
  methods: {
    open(event) {
      alert(event.title);
    },
    abrir_evento(evento) {
      this.adicionar_item_url(evento.id);
      this.evento_selecionado.open = false;
      this.evento_selecionado = evento;
    },
    pegar_titulo(evento) {
      const ids = evento.creditors.map((c) => c.creditor_id);
      if (ids.length === 0) {
        return evento.title;
      }
      return evento.title + " (" + ids.join(",") + ")";
    },
    setar_filtros_url() {
      const filtros = this.$store.getters.getEventsFilters;
      if (filtros.credores) {
        this.$router.replace({ name: "Gestão dos eventos", query: filtros });
      } else {
        this.$router.replace({
          name: "Gestão dos eventos",
          query: { data: filtros.data, evento: filtros.evento },
        });
      }
    },
    ClickableLinks(html, title) {
      const urlRegex = /\b((?:https?:\/\/|www\.)[^\s]+|[^\s]+\.[^\s]{2,})\b/g;

      return html.replace(urlRegex, (url) => {
        let href = url;
        if (!/^https?:\/\//i.test(url) && !/^www\./i.test(url)) {
          href = `http://${url}`;
        }
        let linkColor = title ? 'white' : 'blue';
        return `<a style="text-decoration: underline; color: ${linkColor}" href="${href}" target="_blank">${url}</a>`;
      });
    },
    abrir_modal_criar() {
      this.dialog_criar = true;
      this.adicionar_item_url("new");
    },
    fechar_modal_criar() {
      this.dialog_criar = false;
      this.remover_item_url();
    },
    defineColorByCreditorId(event) {
      let color = "#cf3434";

      if (event.creditors.length == 1) {
        var hashObj = new jsSHA("SHA-256", "TEXT");
        hashObj.update(event.creditors[0].name);
        let fullHash = hashObj.getHash("HEX");

        // Convertendo o hash para valores RGB
        let r = parseInt(fullHash.substring(0, 2), 16);
        let g = parseInt(fullHash.substring(2, 4), 16);
        let b = parseInt(fullHash.substring(4, 6), 16);

        // Diminuindo os valores para cores mais escuras, limitando a redução para garantir que a cor não fique muito clara
        let reductionFactor = 0.8; // Fator de redução para controlar a escuridão da cor
        r = Math.max(Math.round(r * reductionFactor), 0);
        g = Math.max(Math.round(g * reductionFactor), 0);
        b = Math.max(Math.round(b * reductionFactor), 0);

        // Construindo a cor hexadecimal
        color =
          "#" +
          r.toString(16).padStart(2, "0") +
          g.toString(16).padStart(2, "0") +
          b.toString(16).padStart(2, "0");
      }

      return color;
    },
    pegar_eventos() {
      const self = this;
      this.esperar = true;
      const id_evento = this.$route.query.evento;
      this.$store.commit("setEventsFilters", {
        credores: this.ids_credores.join(","),
        data: this.ano_mes,
        evento: id_evento,
      });
      this.setar_filtros_url();

      EventService.list(
        this.ids_credores,
        this.ano_mes_array[1],
        this.ano_mes_array[0]
      )
        .then((retorno) => {
          self.events = retorno.objects;
          self.esperar = false;
        })
        .catch((err) => {
          self.$store.commit(
            "showSnackbar",
            "Falha ao tentar obter os eventos."
          );
          console.error(err);
          self.esperar = false;
        });
    },
    fechar_evento(evento) {
      evento.open = false;
      this.remover_item_url();
    },
    confirmar_remocao(evento) {
      this.item_remover = evento;
      this.dialog_remover = true;
    },
    remover_evento() {
      const self = this;
      this.esperar = true;
      const id = this.item_remover.id;

      EventService.remove(id)
        .then((retorno) => {
          self.events.map((p, index) => {
            if (p.id === id) {
              self.$delete(self.events, index);
            }
          });
          self.dialog_remover = false;
          self.esperar = false;
          this.remover_item_url();
        })
        .catch((err) => {
          self.$store.commit(
            "showSnackbar",
            "Falha ao tentar remover este evento."
          );
          console.error(err);
          self.esperar = false;
        });
    },
    adicionar_item_url(id_evento) {
      this.$store.commit("setEventsFilters", {
        credores: this.ids_credores.join(","),
        data: this.ano_mes,
        evento: id_evento,
      });
      this.setar_filtros_url();
    },
    remover_item_url() {
      this.$store.commit("setEventsFilters", {
        credores: this.ids_credores.join(","),
        data: this.ano_mes,
      });
      this.setar_filtros_url();
    },
    abrir_editar(evento) {
      this.item_edicao = evento;
      this.dialog_editar = true;
    },
    editar(alteracoes) {
      const self = this;
      this.esperar = true;
      const id = this.item_edicao.id;
      const evento_editado = {
        id: id,
        creditors: alteracoes.creditors,
        event_time: alteracoes.event_time + "T00:00:00",
        title: alteracoes.title,
        last_updated_by: store.getters.getLoggedUser.name,
        description: alteracoes.description,
      };

      EventService.update(id, evento_editado)
        .then((retorno) => {
          self.events.map((p, index) => {
            if (p.id === id) {
              self.$set(self.events, index, retorno);
            }
          });
          this.remover_item_url();
          self.dialog_editar = false;
          self.esperar = false;
        })
        .catch((err) => {
          self.$store.commit(
            "showSnackbar",
            "Falha ao tentar editar este evento."
          );
          console.error(err);
          self.dialog_editar = false;
          self.esperar = false;
        });
    },
    criar(novo) {
      const self = this;
      this.esperar = true;
      novo.last_updated_by = store.getters.getLoggedUser.name;

      EventService.create(novo)
        .then((retorno) => {
          self.pegar_eventos();
          self.dialog_criar = false;
          self.esperar = false;
          self.$store.commit("showSnackbar", "Evento criado com sucesso.");
          this.remover_item_url();
        })
        .catch((err) => {
          self.$store.commit(
            "showSnackbar",
            "Falha ao tentar salvar este evento. Confira seus dados e tente novamente!"
          );
          self.dialog_criar = false;
          console.error(err);
          self.esperar = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  color: #ffffff;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
</style>
